import { createStore } from "@tredespace/ui/lib";
import type { TerrainKind } from "../../engine/terrain.ts";
import type { DeckMode } from "../../model/generator.ts";
import type { PlankFamily } from "../../model/solver.ts";

export type GeneratorState = Readonly<{
  numBays: number;
  numLifts: number;
  bayLen: number;
  bayWidth: number;
  terrain: TerrainKind;
  deckMode: DeckMode;
  plankFam: PlankFamily;
  /** Bay index carrying the hatch deck, or -1 for none. */
  hatchBay: number;
  guard: boolean;
  diag: boolean;
}>;

export const generatorState = createStore<GeneratorState>({
  numBays: 4,
  numLifts: 3,
  bayLen: 3050,
  bayWidth: 1250,
  terrain: "flat",
  deckMode: "top",
  plankFam: "mix",
  hatchBay: -1,
  guard: true,
  diag: true,
});
